import { getBonzahPDF } from "api/bonzah/bonzah";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { formatDateToHumanFirendly } from "utils/date-format";
import logo from "images/logo.png";
import { globalJson } from "global/global_json";
import { getPrivacyPolicyContent } from "api/rental-agreement/rental-agreement";

function RentalAgreementPage() {
    const [content, setContent] = useState([]); // Ensure content is always an array
    const [loading, setLoading] = useState(false);

  useEffect(() => {
      const getContent = async () => {
        setLoading(true);
        try {
          const response = await getPrivacyPolicyContent(
            process.env.REACT_APP_ENV !== "prod"
              ? globalJson.dev_company_id
              : globalJson.prod_company_id
          );
  
          // Ensure data is an array or default to an empty array
          setContent(response.data.terms_condition);
          console.log(response);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error("Error fetching content", error);
        }
      };
  
      getContent();
    }, []);

  return (
    <>
      <div className="mt-6 rounded-lg border bg-[#121212] p-6 pb-8 pt-5">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold dark:text-white">
              Car Rental Agreement
            </h1>
            <p className="max-96 text-sm text-[#86909C]">
              Please note the following booking Terms and Conditions apply to
              bookings placed directly on the "Company's Name" website.
            </p>
          </div>
        </div>

        <div className="mb-4 mt-8 flex flex-col md:flex-row">
          <div className="me-0 flex flex-col items-center justify-center rounded-lg  border-gray-300 p-3 md:me-5 md:w-[150px]">
            <img
              alt="Company Image"
              src={logo}
              height={660}
              width={600}
              className="w-full rounded-lg"
            />
          </div>
          <div className="mt-4 flex flex-col justify-center md:mt-0">
            <h2 className="text-xl font-semibold dark:text-white">
              {globalJson.company_name}
            </h2>
            <p className="pt-2 dark:text-white">{globalJson.address}</p>
            <p className="pt-2 dark:text-white">{globalJson.phone}</p>
            <p className="pt-2 dark:text-white">{globalJson.email}</p>
          </div>
        </div>

        <div>
          <div className="flex flex-col md:flex-row">
            <div className="me-3 w-full">
              <div className="rounded-lg border border-muted">
                <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3">
                  <h4 className="text-lg">Customer Information</h4>
                </div>

                <div className="header border-t border-muted p-5">
                  <div className="grid grid-cols-1 gap-3 rounded-lg md:grid-cols-1">
                    <span className="text-base font-bold text-[#777777]">
                      Customer Name
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                </div>

                <div className="header border-t border-muted px-5 py-3">
                  <div className="grid grid-cols-1 gap-3 rounded-lg md:grid-cols-1 lg:gap-1 2xl:gap-1">
                    <span className="text-base font-bold text-[#777777]">
                      Home Address
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium  dark:text-white"></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-3">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      City
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      State
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium  dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Zip
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-2">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Phone
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Birth Date
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium  dark:text-white"></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-3">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Drivers License number
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      State
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium  dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Expires
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium  dark:text-white"></h4>
                  </div>
                </div>
              </div>

              <div className="mt-5 rounded-lg border border-muted">
                <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3">
                  <h4 className="text-lg">Customer Insurance Information</h4>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-2">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Carrier Name
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Agent
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-3">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Policy Number
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Expires
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Phone
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                </div>
              </div>

              {/* <div className="mt-5 rounded-lg border border-muted">
                <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3">
                  <h4 className="text-lg">Additional Driver</h4>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-2">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Additional Driver Name
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Birth Date
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-3">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Drivers License number
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      State
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Expires
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                </div>
              </div> */}

              <div className="mt-5 rounded-lg border border-muted">
                <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3">
                  <h4 className="text-lg">Customer Vehicle Information</h4>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-3">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      License number
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium  dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      State
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      VIN
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium  dark:text-white"></h4>
                  </div>
                </div>

                <div className="header border-t border-muted px-5 py-3">
                  <div className="grid grid-cols-1 gap-3 rounded-lg md:grid-cols-1 lg:gap-1 2xl:gap-1">
                    <span className="text-base font-bold text-[#777777]">
                      Year/Make/Model/Color
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white "></h4>
                  </div>
                </div>
              </div>

              <div className="mt-5 rounded-lg border border-muted">
                <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-2">
                  <h4 className="text-lg">Purchased Insurance Information</h4>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg @md:grid-cols-2">
                  <div className="border border-b-0 border-muted px-5 py-2">
                    <span className="text-base font-bold text-[#777777]">
                      Insurance Provided By
                    </span>
                    <h4 className="rounded-md p-1 ps-3 text-base font-medium">
                      Bonzah
                    </h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-2">
                    <span className="text-base font-bold text-[#777777]">
                      Insurance Name
                    </span>
                    <h4 className="rounded-md p-1 ps-3 text-base font-medium"></h4>
                  </div>
                </div>

                <div className="theme_font_color border border-gray-300 p-4 text-xl font-medium">
                  <span className="text-base font-bold text-[#777777]">
                    Insurance Agreement
                  </span>
                  <h4 className="cursor-pointer rounded-md p-1 ps-3 text-base font-medium underline"></h4>
                </div>
              </div>

              <div className="mt-5 rounded-lg border border-muted">
                <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3">
                  <h4 className="text-lg">Rental Vehicle Information</h4>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-3">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Pickup Date & Time
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Dropoff Date & Time
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Booked At
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-2">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Vehicle ID
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white">
                      {" "}
                    </h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Vehicle Name
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-3">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Vehicle VIN
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      License Number
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white">
                      {" "}
                    </h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Vehicle Colour
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-2">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Minimum Miles
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Maximum Miles
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-0 rounded-lg md:grid-cols-2">
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Miles Allowed
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                  <div className="border border-b-0 border-muted px-5 py-3">
                    <span className="text-base font-bold text-[#777777]">
                      Miles Overage
                    </span>
                    <h4 className="rounded-md p-1 ps-3 font-medium dark:text-white"></h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="rounded-lg border border-muted">
              <div className="grid  gap-0 border-t  border-muted ">
                <h4 className="rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3 text-lg">
                  Bill Summary
                </h4>
              </div>

              <div className="grid grid-cols-2 gap-0 border-t border-muted md:grid-cols-2 ">
                <h4 className="border-r px-5 py-3 text-lg font-medium dark:text-white">
                  Extras
                </h4>
                <h4 className="px-5 py-3 text-lg font-medium dark:text-white"></h4>
              </div>

              {/* <div className="grid grid-cols-2 gap-0 border-t border-muted md:grid-cols-2">
              <h4 className="border-r px-5 py-3 text-lg font-medium dark:text-white">
                ----
              </h4>
              <h4 className="px-5 py-3 text-lg font-medium dark:text-white">
                ----
              </h4>
            </div> */}

              <div className="grid grid-cols-2 gap-0 border-t  border-muted md:grid-cols-2">
                <h4 className="rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3 text-lg">
                  Sub Total
                </h4>
                <h4 className="rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3 text-lg"></h4>
              </div>

              {/* <div className="grid grid-cols-2 gap-0 border-t border-muted md:grid-cols-2 ">
                <h4 className="border-r px-5 py-3 text-lg font-medium dark:text-white">
                  Payments
                </h4>
                <h4 className="px-5 py-3 text-lg font-medium dark:text-white">
                  ----
                </h4>
              </div>

              <div className="grid grid-cols-2 gap-0 border-t border-muted md:grid-cols-2">
                <h4 className="border-r px-5 py-3 text-lg font-medium dark:text-white">
                  Refunds
                </h4>
                <h4 className="px-5 py-3 text-lg font-medium dark:text-white">
                  ----
                </h4>
              </div> */}

              <div className="grid grid-cols-2 gap-0 border-t  border-muted md:grid-cols-2">
                <h4 className="rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3 text-lg">
                  Deposit Held
                </h4>
                <h4 className="rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3 text-lg"></h4>
              </div>
            </div>

            <div className="mt-5 rounded-lg border border-muted">
              <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3">
                <h4 className="text-lg">Renters Signature</h4>
              </div>

              <div className="header border-t border-muted px-5 py-3">
                <div className="grid grid-cols-1 gap-3 rounded-lg md:grid-cols-1 lg:gap-1 2xl:gap-1">
                  {/* <span className="text-base font-bold text-[#777777]">
                    Signature
                  </span> */}
                  <h3
                    className="rounded-md p-2 ps-3 font-medium dark:text-white italic text-3xl"
                    style={{ fontFamily: "'Dancing Script', cursive" }}
                  ></h3>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 rounded-lg border bg-white dark:bg-[#121212] p-4">
           
            <div className="col-span-12 @container">
              <div className="flex flex-col gap-y-4">
                {content?.map((item: any, i: number) => {
                  return (
                    <div className="rounded-lg border border-muted" key={i}>
                      <div className="header rounded-lg dark:bg-[#3c3b3b] bg-[#f7f7f7] px-5 py-3">
                        <h4 className="text-lg">
                          {i + 1}. {item?.title}
                        </h4>
                      </div>

                      <div className="header border-t border-muted p-5 w-full">
                        <div className="grid grid-cols-1 gap-3 rounded-lg w-full">
                          <div
                            className="prose prose-sm text-white break-words"
                            style={{ maxWidth: "100%" }} // Manually remove the max width
                            dangerouslySetInnerHTML={{ __html: item?.content }}
                          />
                        </div>
                      </div>
                      {item?.content_picture === null ||
                      item?.content_picture === "" ||
                      item?.content_picture === "null" ? (
                        ""
                      ) : (
                        <div className="header border-t border-muted p-5">
                          <div className="grid grid-cols-1 gap-3 rounded-lg @md:grid-cols-1">
                            <img
                              alt="terms and conditions image"
                              src={`https://fleet-management-images-upload-be.s3.amazonaws.com/${item?.content_picture}`}
                              height={660}
                              width={600}
                              className="w-full rounded-lg"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RentalAgreementPage;
